if (!customElements.get('sr3-inline-reviews')) {
  customElements.define('sr3-inline-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.slides = [...this.querySelectorAll('[data-review-slide]')];
      this.dots = [...this.querySelectorAll('[data-review-dot]')];
      this.track = this.querySelector('[data-review-track]');
      this.dotList = this.querySelector('[data-review-dots]');
      if (!this.slides.length || !this.track || !this.dotList) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.interval = Math.max(3000, Number(this.dataset.interval) || 4000);
      this.index = 0;
      this.dataset.ready = '';
      this.dotList.hidden = this.slides.length < 2;
      this.show(0);
      this.dotList.addEventListener('click', (event) => {
        const dot = event.target.closest('[data-review-dot]');
        if (!dot || !this.dotList.contains(dot)) return;
        this.show(Number(dot.dataset.reviewDot));
        this.schedule();
      }, options);
      this.dotList.addEventListener('keydown', (event) => {
        const dot = event.target.closest('[data-review-dot]');
        if (!dot) return;
        const focused = this.dots.indexOf(dot);
        let next = focused;
        if (event.key === 'ArrowRight') next = focused + 1;
        else if (event.key === 'ArrowLeft') next = focused - 1;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.slides.length - 1;
        else return;
        event.preventDefault();
        this.show(next);
        this.dots[this.index]?.focus();
        this.schedule();
      }, options);
      this.track.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || event.button !== 0) return;
        this.swipeStart = { x: event.clientX, y: event.clientY };
      }, options);
      this.track.addEventListener('pointerup', (event) => {
        if (!this.swipeStart) return;
        const x = event.clientX - this.swipeStart.x;
        const y = event.clientY - this.swipeStart.y;
        this.swipeStart = null;
        if (Math.abs(x) < 35 || Math.abs(x) < Math.abs(y) * 1.3) return;
        this.show(this.index + (x < 0 ? 1 : -1));
        this.schedule();
      }, options);
      this.track.addEventListener('pointercancel', () => {
        this.swipeStart = null;
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      this.schedule();
    }

    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, position) => {
        const active = position === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      this.dots.forEach((dot, position) => {
        if (position === this.index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    schedule() {
      window.clearTimeout(this.timer);
      if (!this.isConnected || document.hidden || this.motion.matches || this.slides.length < 2) return;
      this.timer = window.setTimeout(() => {
        this.show(this.index + 1);
        this.schedule();
      }, this.interval);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
      this.swipeStart = null;
    }
  });
}
